export default __webpack_public_path__ + "static/ChelseaManning-3a8b47c0fd93ff41fd77cc27044ee344.jpg";